/** @format */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'antd';

import MetaDescription from '../../components/Commons/MetaDescription';
import { partners, formatPhoneDisplay, whatsappUrl } from './partners';

import './style.scss';

const STEPS = [
	{
		n: '01',
		title: 'Agenda tu evaluación médica',
		desc: 'Coordina una consulta online o presencial con uno de los médicos disponibles a través de nuestra página web o por WhatsApp.',
	},
	{
		n: '02',
		title: 'Recibe tu receta',
		desc: 'Si el profesional determina que el tratamiento es adecuado para ti, emitirá tu receta médica.',
	},
	{
		n: '03',
		title: 'Sube tu receta',
		desc: 'Carga tu receta directamente en nuestra plataforma. Nuestro equipo la revisará y validará para continuar con el proceso.',
	},
	{
		n: '04',
		title: 'Compra de forma segura',
		desc: 'Una vez validada tu receta, podrás comprar los productos indicados y recibir tu pedido en la dirección que prefieras.',
	},
];

function PartnerCard({ partner }) {
	const primaryPhone = partner.phones[0];

	return (
		<div className="ph-request-recipe-card">
			<div className="ph-request-recipe-card-inner">
				<div className="ph-request-recipe-card-photo">
					<img alt={partner.name} src={partner.photo} />
				</div>
				<div className="ph-request-recipe-card-body">
					<p className="ph-request-recipe-card-name">{partner.name}</p>
					<p className="ph-request-recipe-card-bio">{partner.bio}</p>
					<div className="ph-request-recipe-card-contacts">
						{partner.phones.map((phone) => (
							<a
								key={phone}
								className="ph-request-recipe-card-phone"
								href={whatsappUrl(phone, partner.name)}
								target="_blank"
								rel="noopener noreferrer"
							>
								{formatPhoneDisplay(phone)}
							</a>
						))}
						{partner.email && (
							<a className="ph-request-recipe-card-email" href={`mailto:${partner.email}`} target="_blank" rel="noopener noreferrer">
								{partner.email}
							</a>
						)}
						{partner.website && (
							<a className="ph-request-recipe-card-web" href={partner.website} target="_blank" rel="noopener noreferrer">
								{partner.website.replace(/^https?:\/\//, '').replace(/\/$/, '')}
							</a>
						)}
					</div>
					<div className="ph-request-recipe-card-cta-wrap">
						<a
							className="ph-request-recipe-card-cta"
							href={whatsappUrl(primaryPhone, partner.name)}
							target="_blank"
							rel="noopener noreferrer"
						>
							Contactar
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}

export default function RequestRecipe() {
	const { t } = useTranslation('global');

	return (
		<div className="ph-request-recipe">
			<MetaDescription title={t('main.metaTitle')} name={'description'} content={t('main.metaContent')} />
			<div className="ph-request-recipe-container">
				<section className="ph-request-recipe-intro">
					<span className="ph-request-recipe-chip">Solicitar receta</span>
					<h1 className="ph-request-recipe-title">¿Aún no tienes receta médica?</h1>
					<p className="ph-request-recipe-text">
						No te preocupes. En <span className="ph-request-recipe-brand">Muy Green</span> puedes contactar a médicos especializados en cannabis
						medicinal para realizar una evaluación de forma online o presencial.
					</p>
					<p className="ph-request-recipe-text">
						Si el profesional determina que el tratamiento es adecuado para ti, emitirá la receta médica correspondiente. Luego solo deberás
						subirla a nuestra plataforma para acceder a nuestros productos.
					</p>
				</section>

				<section className="ph-request-recipe-grid">
					<Row gutter={[10, 10]}>
						{partners.map((partner) => (
							<Col key={partner.id} xs={24} sm={12} lg={8}>
								<PartnerCard partner={partner} />
							</Col>
						))}
					</Row>
				</section>

				<section className="ph-request-recipe-steps">
					<h2 className="ph-request-recipe-title">¿Cómo funciona?</h2>
					{STEPS.map((step) => (
						<div key={step.n} className="ph-request-recipe-step">
							<p className="ph-request-recipe-step-title">
								{step.n}. {step.title}
							</p>
							<p className="ph-request-recipe-step-desc">{step.desc}</p>
						</div>
					))}
				</section>
			</div>
		</div>
	);
}
